import React, { useEffect } from "react";
import "../assets/css/slick-theme.css";
import Sliders from "./Carousal";
import ProductCard from "./Products/ProductLayout";
import ProductsOfTheMonth from "./Products/ProductsOfTheMonth";
import { motion } from "framer-motion";
import Icons from "../assets/ic.png";
import Icons1 from "../assets/paan.png";
import Icons2 from "../assets/manufacture.png";

export default function Home() {
  const uspData = [
    {
      title: "MAKE IN INDIA",
      image: Icons,
      rotate: "clockwise",
    },
    {
      title: "Own Manufacture. – made in high quality materials only",
      image: Icons2,
      rotate: "anticlockwise",
    },
    {
      title: "pre-seasoned and ready for immediate use.",
      image: Icons1,
      rotate: "clockwise",
    },
  ];

  // Animation settings
  const getRotation = (direction) => ({
    whileHover: {
      rotate: direction === "clockwise" ? 360 : -360,
      transition: { duration: 1, ease: "easeInOut" },
    },
    initial: { rotate: 0 },
    animate: { rotate: 0 },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Sliders />

      {/* Products category */}
      <section
        className=" productCatSection"
        // style={{ backgroundColor: "rgb(253, 210, 134)" }}
        style={{
          // background: "#014D4E",
          background: "white",
        }}
      >
        <div className="container py-3">
          <div className="row text-center py-3">
            <div className="col-lg-6 m-auto">
              <h1 className="h2" style={{ color: "#121110ff" }}>
                Our Products
              </h1>
              <p style={{ color: "#131313ff" }}>
                In a mission to deliver high quality products at affordable
                prices
              </p>
            </div>
          </div>
          <div className="row">
            <ProductCard />
          </div>
        </div>
      </section>

      {/* Categories Menu */}
      <section className="container-fluid productsOfMonthSection">
        <div className="container py-0">
          <div className="row text-center pt-2">
            <div className="col-lg-6 m-auto ">
              <h1 className="h2 mt-4" style={{ fontWeight: "400" }}>
                Combo Offers
              </h1>
              <p>We love curating; We love discovering new products</p>
            </div>
          </div>
          <div className="row">
            <ProductsOfTheMonth />
          </div>
        </div>
      </section>
      {/* usp */}
      <section style={styles.section}>
        <h2 style={styles.heading}>Our USP</h2>

        <div style={styles.cardContainer}>
          {uspData.map((usp, index) => (
            <motion.div
              key={index}
              className="usp-card"
              style={styles.card}
              whileHover={{ scale: 1.05 }}
            >
              <motion.img
                height="100%"
                width="100%"
                src={usp.image}
                alt={usp.title}
                style={styles.image}
                {...getRotation(usp.rotate)}
              />
              <h3 style={styles.title}>{usp.title}</h3>
            </motion.div>
          ))}
        </div>
        <style>
          {`
          @media (max-width: 768px) {
            .usp-card-container {
              flex-direction: row;
              align-items: center;
              gap: 10px;
              
            }
          .usp-card {
        width: 100px !important;
        height: auto;
        padding: 12px !important;
      }

      .usp-card img {
        width: 50px !important;
        height: 50px !important;
      }

      .usp-card h3 {
        font-size: 8px !important;
      }
    }
          }
        `}
        </style>
      </section>
    </>
  );
}

const styles = {
  section: {
    padding: "40px 20px",
    background: "white",
    textAlign: "center",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "30px",
    color: "#222",
  },
  cardContainer: {
    display: "flex",
    justifyContent: "center",

    gap: "30px",
    flexWrap: "wrap",
  },
  card: {
    backgroundColor: "#5B0E2D",
    color: "#fff",
    padding: "20px",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    width: "250px",
    textAlign: "center",
  },
  image: {
    width: "150px",
    height: "150px",
    objectFit: "cover",
    borderRadius: "50%",
    marginBottom: "16px",
    border: "4px solid white",
  },
  title: {
    fontSize: "14px",
    fontWeight: "bold",
    lineHeight: "1.4",
  },
};
